/* eslint-disable no-param-reassign */
import { IInputItemType, IUrlParams, IFilterValueType, IUrlParamsObj, ICascadeVal } from "./_type";

/**
 * 设置url筛选器参数为页面筛选器参数
 * @param { Array<IInputItemType>} inputList 页面渲染的筛选器列表（包含下拉、名称等信息）
 * @param {IUrlParamsObj} urlFilterVal url传递的筛选器值
 * @param {IFilterValueType} defaultParams 筛选器默认值
 */
export const getDefaultValueFromUrl = (inputList: Array<IInputItemType>, urlFilterVal: IUrlParamsObj, defaultParams: IFilterValueType): any => {
  const mergeVal = {} as any;
  inputList.forEach(item => {
    // 获取筛选器类型，优先取type，没type取key值
    const key: string = item.type || item.key;
    // 锁定状态，数据格式转换
    mergeVal[item.key] = urlFilterVal?.[key];

    if (!mergeVal[item.key]) {
      mergeVal[item.key] = defaultParams[item.key];
    }
  });
  return mergeVal;
};


/**
 * 获取默认值
 * @param { Array<IInputItemType>} inputList 页面渲染的筛选器列表（包含下拉、名称等信息）
 * @param {IFilterValueType} defaultValue 筛选器默认值
 */
export const getDefaultValue = (inputList: Array<IInputItemType>, defaultValue: IFilterValueType): any => {
  // eslint-disable-next-line array-callback-return
  const renderInputListKey = inputList?.map(item => {
    if (item?.visible === 0) {
      return item.type || item.key;
    }
  })?.filter(item => item) || [];
  const mergeVal = { ...(defaultValue || {}) };
  inputList.forEach((item: any) => {
    const key: string = item?.type || item?.key;
    if ((!mergeVal?.[item?.type] && !mergeVal?.[item?.key]) || renderInputListKey?.includes(key)) {
      mergeVal[key] = defaultValue[key];
    }
  });
  return mergeVal;
};

/**
 * 获取级联筛选器对应第二个tab的值
 * @param { Array<IInputItemType>} item 页面渲染的筛选器列表（包含下拉、名称等信息）
 * @param {IFilterValueType} defaultValue 筛选器默认值
 */
const getCascadeVal = (item: IInputItemType, firstCascadeVal: string[]) => {
  const result: { [key: string]: string; }[] = [];
  item?.options?.forEach((item: ICascadeVal) => {
    if (firstCascadeVal?.includes(item?.code)) {
      result.push(...(item?.list?.map((listItem: { code: any; }) => (listItem?.code) || [])));
    }
  });
  return result;
};

/**
 * 将url中的筛选器参数赋值给页面筛选器的值
 * @param { IInputItemType } item 页面渲染的筛选器列表（包含下拉、名称等信息）
 * @param {string} key 筛选器的key值
 * @param {IUrlParams} urlParams 筛选器的key值
 */
const handleItemDefaultValue = (item: IInputItemType, key: string, urlParams: IUrlParams, obj: any) => {
  const value = decodeURIComponent(urlParams[key] as string);
  const defaultVal = item?.default;
  if (item?.view_type === 'single' || item?.view_type === 'tab' || item?.view_type === 'singleCascade') {
    const resultVal = item?.options?.filter(optionItem => optionItem?.code?.toLowerCase() === value?.toLowerCase()) || [];
    obj[key] = resultVal?.length > 0 ? resultVal?.[0]?.code : defaultVal;
  } else if (item?.view_type === 'multiple') {
    const lowerCaseValue = value?.split(',')?.map(item=>item?.toLowerCase());
    const resultValArr = item?.options?.filter(optionItem => lowerCaseValue?.includes(optionItem?.code?.toLowerCase())) || [];
    const resultVal = resultValArr?.map(item=>item?.code) || [];
    obj[key] = resultVal?.length > 0 ? resultVal : defaultVal;
  } else if (item?.view_type === 'cascade') {
    // 如果后续一个筛选器url接收的参数类型可能不一样，如url可以传品类，或者url可以传游戏，则需要用cascadeType做区分，当前是固定传品类
    // const cascadeType = urlParams?.[`${key}_type`];
    // todo 是否约定级联筛选器名称定义为a_b,后这样处理
    const firstName = key.split('_')[0];
    const secondName = key.split('_')[1];
    const firstCascadeVal = value?.split(',') || [];
    const lowerCaseValue = firstCascadeVal?.map(items=>items?.toLowerCase());
    const resultValArr = item?.options?.filter(optionItem => lowerCaseValue?.includes(optionItem?.code?.toLowerCase())) || [];
    const resultVal = resultValArr?.map(item=>item?.code) || [];
    obj[key] = resultVal?.length > 0 ?  {
      [firstName]: resultVal,
      [secondName]: getCascadeVal(item, resultVal),
      type: secondName
    } : defaultVal;
  } else {
    // 当前url传参只支持 single、multiple、cascade类型，其他类型如range产品要求不做处理其他类型筛选器处理
    obj[key] = defaultVal;
  }
  return obj;
};

// 获取url参数
export const getUrlParams = (urlParams: IUrlParams, inputList: Array<IInputItemType>) => {
  let obj: IUrlParamsObj = {};
  // 筛选器值url传参处理，只处理后端在页面中配置的可展示筛选器的值，后端未配置以及配置的不展示只传默认值的筛选器不做处理
  const realInputList = inputList?.filter(item => item?.visible === 1 || (item.visible !== 0 && !item.visible));
  realInputList.forEach(((item: IInputItemType) => {
    const key: string = item.type || item.key;
    // 其他类型筛选器处理
    if (urlParams[key]) {
      // 其他筛选器统一处理
      obj = handleItemDefaultValue(item, key, urlParams, obj);
    }
  }));
  return obj;
};
